import { Button, Col, Form, Input, message, Row } from "antd"
import PanelLayout from "../../Layout/PanelLayout"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import TextArea from "antd/es/input/TextArea"
import apiClient from "../../Utils/apiClient"
import { useEffect } from "react"

const ScriptForm = () => {
  const [form] = Form.useForm()
  const { id } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const isEditMode = !!id
  const handleFinish = async (values) => {
    const payload = {
      ...values,
    }

    try {
      const result = isEditMode
        ? await apiClient(`tasks/script/update-byId/${id}`, "POST", payload)
        : await apiClient("tasks/script/create", "POST", payload)

      if (result?.success) {
        message.success(result.message || "Script saved successfully")
        navigate("/scripts")
      }
      if (!result?.success) {
        message.info(result?.message)
      }
    } catch (err) {
      console.error("Script submit failed", err)
      message.error("Something went wrong. Please try again.")
    }
  }
  const getData = async (id) => {
    try {
      const res = await apiClient(`tasks/script/get-byId/${id}`, "POST")

      if (res?.success) {
        const script = res.result

        form.setFieldsValue({
          ...script,
          title: script?.title,
          customScript: script?.customScript,
        })
      }
    } catch (error) {
      console.error("Error fetching Scripts by ID", error)
    }
  }

  useEffect(() => {
    if (isEditMode) {
      getData(id)
    }
  }, [id, isEditMode])
  return (
    <PanelLayout
      title={isEditMode ? "Edit Script" : "Add Script"}
      subtitle="Save a reusable script for custom tasks and schedules."
    >
      <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{ title: "Title", customScript: "" }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="title"
                label="Title"
                rules={[{ required: true, message: "Please enter a Title" }]}
              >
                <Input placeholder="Node Version" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="customScript"
                label="Custom Script"
                rules={[
                  { required: true, message: "Please enter a Custom Script" },
                ]}
              >
                <TextArea rows={3} placeholder="node -v" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              {isEditMode ? "Update Script" : "Save Script"}
            </Button>

            <Button
              style={{ marginLeft: 8 }}
              onClick={() => navigate("/scripts")}
            >
              Cancel
            </Button>
          </Form.Item>
        </Form>
    </PanelLayout>
  )
}
export default ScriptForm
